"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fill: "#FF0076",
      d: "M22 5.67a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M15.007 5.43H6.3l-.413-.854a1.997 1.997 0 0 0-1.798-1.127h-1.09a.999.999 0 1 0 0 1.997h1.09L5.78 9.411l2.323 6.482a1 1 0 0 0 .903.572h8.226a.999.999 0 0 0 .88-.525l2.82-6.766a4 4 0 0 1-5.925-3.745ZM8.578 20.742a1.92 1.92 0 0 0 1.41.587c.55 0 1.02-.195 1.411-.587.391-.39.587-.86.587-1.41 0-.55-.196-1.02-.587-1.41a1.923 1.923 0 0 0-1.41-.587c-.55 0-1.02.195-1.41.587a1.923 1.923 0 0 0-.588 1.41c0 .55.196 1.02.587 1.41Zm5.992 0c.39.392.86.587 1.41.587.55 0 1.02-.195 1.41-.587.392-.39.587-.86.587-1.41 0-.55-.195-1.02-.586-1.41a1.923 1.923 0 0 0-1.41-.587c-.55 0-1.02.195-1.411.587a1.923 1.923 0 0 0-.587 1.41c0 .55.195 1.02.587 1.41Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};